<template>
  <a-form ref='form' :model='search' :initialValues="search" :onFinish='pageSearchChange' layout='inline'>
    <a-form-item label="大标物流码" name='code_sn'>
      <a-input style="width: 270px" v-model:value="search.code_sn" placeholder="请输入关键词进行搜索" />
    </a-form-item>
    <a-form-item label="关联状态" name='status'>
      <a-select v-model:value="search.status" :style="{width:'140px'}" placeholder="全部">
        <a-select-option value="">全部</a-select-option>
        <a-select-option value="1">关联中</a-select-option>
        <a-select-option value="2">解除关联</a-select-option>
        <a-select-option value="3">单独出入退</a-select-option>
      </a-select>
    </a-form-item>
    <a-form-item>
      <a-button type="primary" htmlType='submit'>搜索</a-button>
    </a-form-item>
  </a-form>
  <a-table class='m-t-20' :pagination='false' :loading='listLoading' bordered :columns='columns' :data-source='list'>
  </a-table>
  <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange"  :show-total="total => `总数: ${total} `" />
</template>
<script>
import useTableSearch from "@/hooks/useTableSearch";
import {get_virtual_info} from '@/api/antiFleeing'
import { onMounted } from '@vue/runtime-core';
export default {
  props:{
    codedata:Object
  },  
  setup(props) {
      const defSearch={
            virtual_sn:'',
            limit:10,
            page:1,
            status:'',
            code_sn:""
      }
    let columns = [
      {
        title: "大标物流码",
        dataIndex: "code_sn",
        key: "code_sn",
      },
      {
        title: "关联状态",
        dataIndex: "status_text",
        key: "status_text",
      },
    ];
    const {
      pageCurrentChange,
      pageSizeChange,
      search,
      list,
      initData,
      total,
      pageSearchChange,
      listLoading,
    } = useTableSearch({ data: defSearch });
    const tableHoosks = {
      pageCurrentChange,
      pageSizeChange, 
      search,
      initData,
      list,
      total,
      pageSearchChange,
      listLoading,
    };
    onMounted(()=>{
      console.log(search.value.virtual_sn,props)
      search.value.virtual_sn=props.codedata.virtual_sn
      tableHoosks.initData(get_virtual_info,search.value);
    })
    return {
      ...tableHoosks,
      columns,
    };
  },
};
</script>